import React from 'react';
import { Icon } from './Icon.js';
export const IconPaperclip = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M18 6V15.5C18 19.0899 15.0899 22 11.5 22C7.91015 22 5 19.0899 5 15.5V6.5C5 4.01472 7.01472 2 9.5 2C11.9853 2 14 4.01472 14 6.5V14.5C14 15.8807 12.8807 17 11.5 17C10.1193 17 9 15.8807 9 14.5V8", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconPaperclip.js.map